import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../../../auth/auth.service';
import { resolveEventFormOrganizationId } from './event-form-org.util';

/**
 * Visibility for extra-room fields on add/edit event forms.
 * Requires org setting events_additional_rooms_enabled.
 */
export function event_additional_rooms_field_visible(
  service: ComponentDataSourceService
): DataSourceFunction {
  return {
    name: 'event_additional_rooms_field_visible',
    description: 'Whether extra rooms can be added on events (org setting events_additional_rooms_enabled).',
    execute: (params?: LoadDataParams): Observable<{ visible: boolean }> => {
      const auth = service.injector.get(AuthService);
      const orgId = resolveEventFormOrganizationId(params, auth);
      if (orgId == null) {
        return of({ visible: false });
      }
      const obs = service.executeDataSource('org_settings', { organizationId: orgId });
      if (!obs) {
        return of({ visible: false });
      }
      return obs.pipe(
        map((res: { data?: Record<string, unknown> }) => {
          const value = res?.data?.['events_additional_rooms_enabled'];
          const visible = value === true || value === 'true' || value === 1 || value === '1';
          return { visible };
        }),
        catchError(() => of({ visible: false }))
      );
    },
  };
}
